export default {"src":"/_next/static/media/kiwi.a0a7f23a.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};